import React from 'react'
import Carousel from '@brainhubeu/react-carousel'
import '@brainhubeu/react-carousel/lib/style.css'
import IconControl from './icon-control'
import colours from '../lib/colours'
import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: 28px;
  margin-top: 28px;
`

const ImageContainer = styled.div`
  position: relative;
`

const DotContainer = styled.div`
  text-align: center;
  padding-top: 6px;
`

const RoundDiv = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${colours.white};
  cursor: pointer;
  position: absolute;
  top: 50%;
  margin: 20px;
  margin-top: -20px;
  box-shadow: 0 4px 4px 2px rgba(0,0,0,0.5);
  padding: 7px;
  font-size: 20px;
  padding-left: 14px;
}

`

const dotSize = 12

const Dot = styled.div`
  width: ${dotSize}px;
  height: ${dotSize}px;
  background: ${colours.grey};
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  margin: 8px;
`

const ActiveDot = styled(Dot)`
  background: ${colours.mediumBlue};
`

const Caption = styled.div`
  font-size: smaller;
  margin-top: 12px;
`
const ItalicisedSpan = styled.span`
  font-style: italic;
`

interface IState {
  value: number
}

interface IProps {
  images: string[]
  credits?: string[]
}

class CarouselControl extends React.Component<IProps> {
  state: IState = {
    value: 0
  }

  handleClick = (newValue: number) => {
    const value = Math.max(0, Math.min(this.props.images.length - 1, newValue))
    this.setState({ value })
  }

  renderArrowLeft = () => {
    if (this.state.value <= 0) return <></>
    return (
      <RoundDiv onClick={this.handleClick.bind(null, this.state.value - 1)}>
        <IconControl icon="chevron-left" />
      </RoundDiv>
    )
  }
  renderArrowRight = () => {
    if (this.state.value >= this.props.images.length - 1) return <></>
    return (
      <RoundDiv
        onClick={this.handleClick.bind(null, this.state.value + 1)}
        style={{ right: 0 }}
      >
        <IconControl icon="chevron-right" />
      </RoundDiv>
    )
  }

  renderDot = (_: string, index: number) => {
    if (index === this.state.value)
      return (
        <ActiveDot key={index} onClick={this.handleClick.bind(null, index)} />
      )
    return <Dot key={index} onClick={this.handleClick.bind(null, index)} />
  }

  renderCredits = (creditText: string) => {
    if (creditText && creditText.indexOf('*') !== -1) {
      return (
        <Caption>
          {creditText.split('*').map((x, i) => {
            if (i % 2 === 0) {
              return <span>{x}</span>
            } else {
              return <ItalicisedSpan>{x}</ItalicisedSpan>
            }
          })}
        </Caption>
      )
    } else {
      return <Caption>{creditText}</Caption>
    }
  }

  render() {
    return (
      <Container>
        <ImageContainer>
          <Carousel
            value={this.state.value}
            addArrowClickHandler
            draggable={false}
          >
            {this.props.images.map(x => {
              const parts = x.split('/')
              const altText = parts[parts.length - 1]
                .split('.')[0]
                .replace(/_/g, ' ')
                .replace(/-/g, ' ')
              return <img src={x} key={x} alt={altText} />
            })}
          </Carousel>
          {this.renderArrowLeft()}
          {this.renderArrowRight()}
        </ImageContainer>
        <DotContainer>{this.props.images.map(this.renderDot)}</DotContainer>
        {this.props.credits &&
          this.renderCredits(this.props.credits[this.state.value])}
      </Container>
    )
  }
}

export default CarouselControl
